import { api } from '@/services';
import type { FiltrosListaNfse, ListaNfsePayload, ListaNfseResponse } from '../types';

function normalizeListaNfseResponse(response: ListaNfseResponse): ListaNfseResponse {
  if (response.data.qtd_total_registros !== 0) return response;

  return {
    ...response,
    data: {
      ...response.data,
      lista: [],
      lista_agrupado: [],
    },
  };
}

export async function fetchListaNfse(filtros?: FiltrosListaNfse): Promise<ListaNfseResponse> {
  const fornecedorValor = filtros?.cnpj || filtros?.razaoSocial || '';
  const fornecedorDocumento = fornecedorValor.replace(/\D/g, '');
  const isCNPJ = /^\d{14}$/.test(fornecedorDocumento);
  const cnpjContribuinte = (filtros?.empresaCnpjs || filtros?.empresaId || '').replace(/\D/g, '');

  const payload: ListaNfsePayload = {
    pagina_numero: filtros?.paginaNumero || 1,
    pagina_quantidade_por: filtros?.paginaQuantidadePor || 50,
    cnpj: isCNPJ ? fornecedorDocumento : '',
    razao_social: !isCNPJ && fornecedorValor ? fornecedorValor : '',
    data_emissao_de: filtros?.dataInicio || '',
    data_emissao_ate: filtros?.dataFim || '',
    numero: filtros?.numeroDoc || '',
    chave_acesso: filtros?.chaveAcessoDoc || '',
    produto_codigo: filtros?.codigoServico || '',
    tipo_operacao: filtros?.direitoCredito || '',
    direito_credito: filtros?.direitoCredito || '',
    ordenar_por: filtros?.ordenarPor || '',
    ordenar_direcao: filtros?.ordenarDirecao || '',
    Status: filtros?.status ?? '',
    entrada_saida: filtros?.entradaSaida || '1',
    cnpj_contribuinte: cnpjContribuinte,
    CNPJ_Contribuinte: cnpjContribuinte,
  };

  const response = await api.post<ListaNfseResponse, ListaNfsePayload>(
    'Documento/ListaNFS',
    payload
  );

  return normalizeListaNfseResponse(response);
}
